import { Inject } from '@angular/core';
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA, MatSelect } from '@angular/material';
import { ToastrManager } from 'ng6-toastr-notifications';
import { DatabaseService } from 'src/_services/DatabaseService';
import * as moment from 'moment';
import { Router } from '@angular/router';




@Component({
  selector: 'app-bottom-sheet',
  templateUrl: './bottom-sheet.component.html'
})
export class BottomSheetComponent implements OnInit {
  search: any = {};
  downurl: any = '';
  today_date: any = new Date();
  lastPageData: any = {}
  filter: any = {};
  monthlyWorkReport: any = []
  excel_loader: boolean = false;
  states: any = [];
  usersList: any = [];
  reportingOne = [];
  hod: any = [];
  reportingTwo = [];
  user = [];
  months = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];
  YearList = [
    '2024', '2025', '2026', '2027'
  ];
  drlist: any = [];
  threeMonthsAgo: Date;

  constructor(@Inject(MAT_BOTTOM_SHEET_DATA) public data: any,public service: DatabaseService,public router: Router, private bottomSheetRef: MatBottomSheetRef<BottomSheetComponent>, public toast: ToastrManager, private cdr: ChangeDetectorRef) {
    this.downurl = service.downloadUrl;

    this.lastPageData = data;
    console.log(this.lastPageData,"this.lastPageData")

    if(data.filterPage == 'Dashboard'){
    }
    if (this.lastPageData.filterPage == 'Expense' || this.lastPageData.filterPage == 'product_wise_secondary_report' || this.lastPageData.filterPage == 'distribution_list') {
      this.getSalesUser('');
      this.getreportingmanager('');
    }
    if (this.lastPageData.filterPage == 'visitActivityReport') {
      this.userList1('');
    }
    if (this.lastPageData.filterPage == 'userWorkReport') {
      this.getSalesUserForReporting()
    }
    // this.userList('')
    // this.getAllList('', '', '', '','');
    // this.getAllList1('', '', '', '');
    if(this.lastPageData.filterPage != 'report_list'){
    this.distributorList('');
    }



   if(this.lastPageData.filterValue){
 this.search.date_from=this.lastPageData.filterValue.date_from
 this.search.date_to=this.lastPageData.filterValue.date_to
}

}

ngOnInit() {

if(this.lastPageData.filterValue){
 this.data.hod_reporting=this.lastPageData.filterValue.hod_reporting
 console.log(this.data.hod_reporting,'this.data.hod_reporting');
 this.getAllList('','','','','')
 this.userList1('');
}else{
  this.getAllList('','','','','')
  this.userList1('');
}

  }
  getMaxDate(): Date {
    if (!this.search.date_from) {
      return this.today_date;
    }

    // Create a new date object to avoid modifying the original
    const maxDate = new Date(this.search.date_from);
    // Add 3 months to the date_from
    maxDate.setMonth(maxDate.getMonth() + 3);

    // Return the earlier of: today's date or date_from + 3 months
    return maxDate < this.today_date ? maxDate : this.today_date;
  }
  public date(date) {
    if (this.search.date_from) {
      this.search.date_from = moment(this.search.date_from).format('YYYY-MM-DD');
    }
    if (this.search.date_to) {
      this.search.date_to = moment(this.search.date_to).format('YYYY-MM-DD');
    }
  }
  salesUser: any = [];
  reportingManager: any = [];


  getSalesUser(searchValue) {
    let header;
    if (this.lastPageData.filterPage == 'Expense' || this.lastPageData.filterPage == 'product_wise_secondary_report' || this.lastPageData.filterPage == 'distribution_list') {
      header = 'Expense/salesUserListExpense';
    }

    this.service.post_rqst({ 'search': searchValue }, header).subscribe((response => {
      if (response['statusCode'] == 200) {
        this.salesUser = response['all_sales_user'];
        if (this.lastPageData.filterPage == 'product_wise_secondary_report') {
          this.salesUser.unshift({ 'id': 'All', 'name': 'All', 'role_name': '' })
        }
      } else {
        this.toast.errorToastr(response['statusMsg']);
      }
    }));
  }


  getreportingmanager(searchValue) {
    let header;
    if (this.lastPageData.filterPage == 'Expense' || this.lastPageData.filterPage == 'product_wise_secondary_report' || this.lastPageData.filterPage == 'distribution_list') {
      header = 'expense/getReportingManager';
    }

    this.service.post_rqst({ 'search': searchValue }, header).subscribe((response => {
      if (response['statusCode'] == 200) {
        this.reportingManager = response['users'];
        if (this.lastPageData.filterPage == 'product_wise_secondary_report') {
          this.reportingManager.unshift({ 'id': 'All', 'name': 'All', 'role_name': '' })
        }
      } else {
        this.toast.errorToastr(response['statusMsg']);
      }
    }));
  }

  value(search){
    this.router.navigate(['/expense-list/expense-user-detail-page/' + search.assigned_sales_user_name])
    this.bottomSheetRef.dismiss(this.search);
    this.service.setData(search)
  }
  // allSalesUser1(action) {



  //   if (this.search.allSalesUser == true) {
  //       const productData = [];
  //       for (let i = 0; i < this.usersList.length; i++) {
  //           productData.push(this.usersList[i].id)
  //       }
  //       this.search.emp_code = productData;
  //       console.table(this.search.emp_code)

  //   } else {
  //       this.search.emp_code = [];
  //       console.table(this.search.emp_code)
  //   }
  // }

  allSalesUser1(action) {
    console.log(action)


    // if (action == 'allSalesUser') {
    // setTimeout(() => {
    if (this.search.allSalesUser == true) {
      const productData = [];
      for (let i = 0; i < this.usersList.length; i++) {
        productData.push(this.usersList[i].id)
      }
      console.log(productData)
      this.search.emp_code = productData;
      console.table(this.search.emp_code)

    } else {
      this.search.emp_code = [];
      console.table(this.search.emp_code)
    }
    // }, 100);
    // }
  }


  getValue() {
    this.bottomSheetRef.dismiss(this.search);
  }
  getDashboardValue() {
    this.search.employee_id=this.data.assigned_sales_user_name
    this.search.hod_reporting=this.data.hod_reporting
    this.search.rsm2=this.data.rsm2
    this.bottomSheetRef.dismiss(this.search);
  }


  givenBudgetExcelDownload() {

    this.service.post_rqst({ 'month': this.search.month, 'year': this.search.year }, "Excel/eventBudgetExcelFilter").subscribe((result => {
      if (result['msg'] == true) {
        this.user = result['result'];
        window.open(this.downurl + result['filename'])
        console.log(this.user)
        const userData = [];
        if (this.search.hod_reporting) {
          for (let i = 0; i < this.user.length; i++) {
            userData.push(this.user[i].id);
            console.log('====================================');
            console.log(userData);
            console.log('====================================');
          }
          this.search.assigned_sales_user_name = userData.map(String);
          console.log('====================================');
          console.log(this.search.assigned_sales_user_name);
          console.log('====================================');
        }
      }
      else {
        this.toast.errorToastr(result['statusMsg'])
      }
    }));
  }


  // userList1(search) {

  //   this.service.post_rqst({ 'state': this.data.state, 'rm1': this.data.rsm1, 'rm2': this.data.rm2, 'hod': this.data.hod_reporting, 'search': search }, "Reports/fetchFilterUserData").subscribe((result => {
  //     if (result['statusCode'] == 200) {
  //       this.user = result['result'];
  //       const userData = [];
  //       if (this.data.state || this.data.rsm1 || this.data.rm2 || this.data.hod_reporting) {
  //         for (let i = 0; i < this.user.length; i++) {
  //           userData.push(this.user[i].id);
  //         }
  //         this.data.assigned_sales_user_name = userData.map(String);
  //       }
  //     }
  //     else {
  //       this.toast.errorToastr(result['statusMsg'])
  //     }
  //   }));
  // }


getAllList(state, rsm1, rsm2, hod,hod_id) {
  // if(this.lastPageData.filterValue.hod_reporting){
//  this.data.hod_reporting=this.lastPageData.filterValue.hod_reporting
// }
console.log(this.data.hod_reporting,'this.data.hod_reporting');


    this.service.post_rqst({ 'state': state, 'rsm1': rsm1, 'rsm2': rsm2, 'hod': hod,'hod_id': hod_id?hod_id:this.data.hod_reporting,'filterType':this.lastPageData.filterType?this.lastPageData.filterType:'dashboard' }, "Master/fetchFilterData").subscribe((result => {
      console.log(result, 'result');
      if (result['statusCode'] == 200) {
        this.states = result['result']['state'];
        this.hod = result['result']['hod'];
        this.reportingTwo = result['result']['rm2'];
        this.reportingOne = result['result']['rm1'];



 this.cdr.detectChanges();
if(this.lastPageData.filterValue.rsm2){
 this.data.rsm2=this.lastPageData.filterValue.rsm2
}
 this.cdr.detectChanges();
      }
      else {
        this.toast.errorToastr(result['statusMsg'])
      }
    }));
  }

  userList1(search) {

    this.service.post_rqst({ 'state': this.search.state, 'rm1': this.search.rsm1, 'rm2': this.search.rm2, 'hod': this.search.hod_reporting?this.search.hod_reporting:this.data.hod_reporting, 'search': search,'filterType':this.lastPageData.filterType?this.lastPageData.filterType:'dashboard' }, "Reports/fetchFilterUserData").subscribe((result => {
      if (result['statusCode'] == 200) {
        this.user = result['result'];
        console.log(this.user)
        const userData = [];
        if (this.search.hod_reporting) {
          for (let i = 0; i < this.user.length; i++) {
            userData.push(this.user[i].id);
            console.log('====================================');
            console.log(userData);
            console.log('====================================');
          }
          this.search.assigned_sales_user_name = userData.map(String);
          console.log('====================================');
          console.log(this.search.assigned_sales_user_name);
          console.log('====================================');
        }


        if(this.lastPageData.filterValue.employee_id){
             this.data.assigned_sales_user_name=this.lastPageData.filterValue.employee_id
            }


            this.cdr.detectChanges(); // Manually trigger change detection
      }
      else {
        this.toast.errorToastr(result['statusMsg'])
      }
    }));
  }



  // getAllList1(state, rsm1, rsm2, hod) {
  //   this.service.post_rqst({ 'state': state, 'rsm1': rsm1, 'rsm2': rsm2, 'hod': hod }, "Reports/fetchFilterData").subscribe((result => {

  //     if (result['statusCode'] == 200) {
  //       this.states = result['result']['state'];
  //       this.hod = result['result']['hod'];
  //       this.reportingTwo = result['result']['rm2'];
  //       this.reportingOne = result['result']['rm1'];
  //     }
  //     else {
  //       this.toast.errorToastr(result['statusMsg'])
  //     }
  //   }));
  // }
  selectAll(checked: boolean) {
    if (checked) {
      // If "Select All" checkbox is checked, select all options
      this.search.distributor_id = this.drlist.map(row => row.id);
    } else {
      // If "Select All" checkbox is unchecked, deselect all options
      this.search.distributor_id = [];
    }
  }

  userList(search) {

    console.log(this.lastPageData.hod_reporting,'this.lastPageData.hod_reporting');

    this.service.post_rqst({ 'state': this.search.state, 'rm1': this.search.rsm1, 'rm2': this.search.rm2, 'hod': this.search.hod_reporting, 'search': search }, "Order/fetchFilterUserExcel").subscribe((result => {
      if (result['statusCode'] == 200) {
        this.user = result['result'];
        console.log(this.user)
        const userData = [];
        if (this.search.hod_reporting) {
          for (let i = 0; i < this.user.length; i++) {
            userData.push(this.user[i].id);
            console.log('====================================');
            console.log(userData);
            console.log('====================================');
          }
          this.search.assigned_sales_user_name = userData.map(String);
          console.log('====================================');
          console.log(this.search.assigned_sales_user_name);
          this.SecondarySaleDistributor('',this.search.assigned_sales_user_name)
          console.log('====================================');
        }
      }
      else {
        this.toast.errorToastr(result['statusMsg'])
      }
    }));
  }
  selectAlllist: boolean = false;
  selectAlllistEmploye: boolean = false;

  toggleSelectAll() {
    if (this.selectAlllist) {
      // If Select All is checked, set search.hod_reporting to an array of all hod_id values
      this.search.hod_reporting = this.hod.map(item => item.hod_id);
      this.userList('')

    } else {
      // If Select All is unchecked, clear the search.hod_reporting array
      this.search.hod_reporting = [];
      this.search.assigned_sales_user_name = ''
    }
  }

  toggleSelectAll1() {
    if (this.selectAlllist) {
      // If Select All is checked, set search.hod_reporting to an array of all hod_id values
      this.search.hod_reporting = this.hod.map(item => item.hod_id);
      this.userList1('')

    } else {
      // If Select All is unchecked, clear the search.hod_reporting array
      this.search.hod_reporting = [];
      this.search.assigned_sales_user_name = ''
    }
  }
  selectAllOptions() {
    console.log('====================================');
    console.log('tetses turew');
    console.log('====================================');
    if (this.selectAlllistEmploye) {
      this.search.assigned_sales_user_name = this.user.map(item => item.id);
      console.log('====================================');
      console.log();
      console.log('====================================');
    } else {
      this.search.assigned_sales_user_name=[];
      this.search.assigned_sales_user_name = ''
    }
    // Extracting IDs from the user array and assigning them to ngModel

  }
  allSelect(type) {
    if (type == "state") {
      setTimeout(() => {
        if (this.search.checkUser == true) {
          const array = [];
          for (let i = 0; i < this.states.length; i++) {
            array.push(this.states[i].state_name);
          }
          this.search.state = array.map(String);
        }
        else {
          this.search.state = '';
          this.search.assigned_sales_user_name = '';
        }

      }, 50);
    }
    else if (type == "rm1") {
      setTimeout(() => {
        if (this.search.rm1 == true) {
          const array = [];
          for (let i = 0; i < this.reportingOne.length; i++) {
            array.push(this.reportingOne[i].id);
          }
          this.search.rsm1 = array.map(String);
        }
        else {
          this.search.rsm1 = '';
          this.search.assigned_sales_user_name = '';

        }

      }, 50);
    }

    else if (type == "rm2") {

      setTimeout(() => {
        if (this.search.rm2 == true) {
          const array = [];
          for (let i = 0; i < this.reportingTwo.length; i++) {
            array.push(this.reportingTwo[i].rsm2_id);
          }
          this.search.rsm2 = array.map(String);
        }
        else {
          this.search.rsm2 = '';
          this.search.assigned_sales_user_name = '';

        }

      }, 50);
    }

    else if (type == "hod_user") {
      setTimeout(() => {
        if (this.search.hod_user == true) {
          const array = [];
          for (let i = 0; i < this.hod.length; i++) {
            array.push(this.hod[i].hod_id);
          }
          this.search.hod_reporting = array.map(String);
        }
        else {
          this.search.hod_reporting = '';
          this.search.assigned_sales_user_name = '';

        }
      }, 50);
    }
    else {
      setTimeout(() => {
        if (this.search.employee == true) {
          const array = [];
          for (let i = 0; i < this.user.length; i++) {
            array.push(this.user[i].id);
          }
          this.search.assigned_sales_user_name = array.map(String);
        }
        else {
          this.search.assigned_sales_user_name = '';
        }
      }, 50);
    }
  }
  distributorList(searcValue) {
    console.log('hello bro')
    this.service.post_rqst({ 'search': searcValue }, "CustomerNetwork/distributorsList").subscribe((result => {
      if (result['statusCode'] == 200) {
        this.drlist = result['distributors'];
      } else {
        this.toast.errorToastr(result['statusMsg']);
      }
    }))
  }

  SecondarySaleDistributor(searcValue,userId) {
    console.log('hello bro',userId)
    console.log(this.search.assigned_sales_user_name,'this.search.assigned_sales_user_name');
    this.service.post_rqst({ 'search': searcValue,'userId':userId?userId:this.search.assigned_sales_user_name}, "CustomerNetwork/distributorsListSecondarySale").subscribe((result => {
      if (result['statusCode'] == 200) {
        this.drlist = result['distributors'];
      } else {
        this.toast.errorToastr(result['statusMsg']);
      }
    }))
  }

  getSalesUserForReporting() {
    this.excel_loader = true;
    this.service.post_rqst({}, 'Event/fetchEventBudgetUser').subscribe((r) => {
      if (r['statusCode'] == 200) {
        this.excel_loader = false;
        this.usersList = r['result'];
      }
      else {
        this.excel_loader = false;
        this.toast.errorToastr(r['statusMsg']);
      }
    }, err => {
      this.excel_loader = false;
    })

  }

  getAllListDashboard(state, rsm1, rsm2, hod) {
    this.service.post_rqst({ 'state': state, 'rsm1': rsm1, 'rsm2': rsm2, 'hod': hod }, "Reports/fetchFilterData").subscribe((result => {

      if (result['statusCode'] == 200) {
        this.states = result['result']['state'];
        this.hod = result['result']['hod'];
        this.reportingTwo = result['result']['rm2'];
        this.reportingOne = result['result']['rm1'];
      }
      else {
        this.toast.errorToastr(result['statusMsg'])
      }
    }));
  }


  userListdashboard(search) {

    this.service.post_rqst({ 'state': this.data.state, 'rm1': this.data.rsm1, 'rm2': this.data.rsm2, 'hod': this.data.hod_reporting, 'search': search,'filterType':this.lastPageData.filterType }, "Reports/fetchFilterUserData").subscribe((result => {
      if (result['statusCode'] == 200) {
        this.user = result['result'];
        const userData = [];
        if (this.data.state || this.data.rsm1 || this.data.rsm2 || this.data.hod_reporting) {
          for (let i = 0; i < this.user.length; i++) {
            userData.push(this.user[i].id);
          }
          this.data.assigned_sales_user_name = userData.map(String);
        }
      }
      else {
        this.toast.errorToastr(result['statusMsg'])
      }
    }));
  }

  allSelectDashboard(type) {
    if (type == "state") {
      setTimeout(() => {
        if (this.data.checkUser == true) {
          const array = [];
          for (let i = 0; i < this.states.length; i++) {
            array.push(this.states[i].state_name);
          }
          this.data.state = array.map(String);
        }
        else {
          this.data.state = '';
          this.data.assigned_sales_user_name = '';
        }

      }, 50);
    }
    else if (type == "rm1") {
      setTimeout(() => {
        if (this.data.rm1 == true) {
          const array = [];
          for (let i = 0; i < this.reportingOne.length; i++) {
            array.push(this.reportingOne[i].id);
          }
          this.data.rsm1 = array.map(String);
        }
        else {
          this.data.rsm1 = '';
          this.data.assigned_sales_user_name = '';

        }

      }, 50);
    }

    else if (type == "rm2") {

      setTimeout(() => {
        if (this.data.rm2 == true) {
          const array = [];
          for (let i = 0; i < this.reportingTwo.length; i++) {
            array.push(this.reportingTwo[i].rsm2_id);
          }
          this.data.rsm2 = array.map(String);
        }
        else {
          this.data.rsm2 = '';
          this.data.assigned_sales_user_name = '';

        }

      }, 50);
    }

    else if (type == "hod_user") {
      setTimeout(() => {
        if (this.data.hod_user == true) {
          const array = [];
          for (let i = 0; i < this.hod.length; i++) {
            array.push(this.hod[i].hod_id);
          }
          this.data.hod_reporting = array.map(String);
        }
        else {
          this.data.hod_reporting = '';
          this.data.assigned_sales_user_name = '';

        }
      }, 50);
    }
    else {
      setTimeout(() => {
        if (this.data.employee == true) {
          const array = [];
          for (let i = 0; i < this.user.length; i++) {
            array.push(this.user[i].id);
          }
          this.data.assigned_sales_user_name = array.map(String);
        }
        else {
          this.data.assigned_sales_user_name = '';
        }
      }, 50);
    }
  }

}
